import OwnerPageSearch from "containers/owner/page/OwnerPageSearch";
import { Modal } from "react-bootstrap";
import React from "react";
import { createElementIdFactory } from "utils/elementIds";
import "containers/common/Detail.css";

function OwnerPageSearchModal({
    user,
    userPermissions,
    refreshDataSet,
    existingOwnerParents,
    onOwnerParentAdded,
    controlType,
    data,
    updateTableState,
    saveRecord,
    buyerSellers,
    ownerid,
    saleid,
    properties,
    show,
    onClose,
    toggleOwnerPageSearchDialog,
}) {

    const createId = createElementIdFactory("owner-page-search-modal");
    const handleClose = onClose || toggleOwnerPageSearchDialog;

    return (
        <Modal id={createId("modal")} show={show} onHide={handleClose} dialogClassName="owner-search-modal-wide" centered>
            <Modal.Header id={createId("header")} closeButton>
                <Modal.Title>Owner Index Search</Modal.Title>
            </Modal.Header>
            <Modal.Body id={createId("body")}>
                <OwnerPageSearch
                    isAuthenticated={true}
                    user={user}
                    userPermissions={userPermissions}
                    properties={properties}
                    controlType={controlType || "table2"}
                    showAddButton={true}
                    buyerSellers={buyerSellers}
                    saleid={saleid}
                    ownerid={ownerid}
                    existingOwnerParents={existingOwnerParents}
                    onOwnerParentAdded={onOwnerParentAdded}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    refreshDataSet={refreshDataSet}
                    data={data}
                    onClose={handleClose}
                />
            </Modal.Body>
        </Modal>
    );
}
export default OwnerPageSearchModal;